'use client';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logout } from './auth.slice';

// Tracks which countries the current user has already requested expansion to,
// so we can swap the banner CTA to a confirmed pill instead of a re-submit.
// Cleared on logout — the request is tied to the signed-in user.

interface ExpansionRequestsState {
    countries: string[];
}

const initialState: ExpansionRequestsState = {
    countries: []
};

const expansionRequestsSlice = createSlice({
    name: 'expansionRequests',
    initialState,
    reducers: {
        addExpansionRequest(state, action: PayloadAction<string>) {
            const country = action.payload?.toUpperCase?.() || '';
            if (!country) return;
            if (!state.countries.includes(country)) {
                state.countries.push(country);
            }
        },
        resetExpansionRequests(state) {
            state.countries = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(logout, (state) => {
            state.countries = [];
        });
    }
});

export const { addExpansionRequest, resetExpansionRequests } =
    expansionRequestsSlice.actions;
export default expansionRequestsSlice.reducer;
